/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

function getParameterByName(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

$(function($) {
	if (getParameterByName('errorcode') || getParameterByName('newsletter-success')) {
		if ($('#dealer-report-newsletter').length) {
			var offset = $('#dealer-report-newsletter').offset().top - 100;

			$('html, body').animate({
				scrollTop: offset + 'px'
			}, 500);
		}
	}
});
